<template>
  <main v-loading="loading">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: './visa' }">签证</el-breadcrumb-item>
      <el-breadcrumb-item>签证列表</el-breadcrumb-item>
    </el-breadcrumb>
    <dl>
      <dt>
        <h3>
          <span>筛选条件：</span>
          <el-tag disable-transitions v-for="v in getSelected" :key="v.value">{{ v.value }}</el-tag>
          <i class="icon-clear" @click="clearSelected"></i>
        </h3>
        <search :defaultValue="info.name" @change="changeKeyWord" />
      </dt>
      <dd>
        <h4>签证类别：</h4>
        <nav>
          <a v-for="(v, i) in select.types" :key="v" :class="{ on: i === select.typeIndex }"
            @click="changeSelect('typeIndex', i)">{{ v }}</a>
        </nav>
      </dd>
      <dd>
        <h4>签证形式：</h4>
        <nav>
          <a v-for="(v, i) in select.forms" :key="v" :class="{ on: i === select.formIndex }"
            @click="changeSelect('formIndex', i)">{{ v }}</a>
        </nav>
      </dd>
      <dd>
        <h4>服务承诺：</h4>
        <nav>
          <a v-for="(v, i) in select.serves" :key="v" :class="{ on: i === select.serveIndex }"
            @click="changeSelect('serveIndex', i)">{{ v }}</a>
        </nav>
      </dd>
    </dl>
    <section>
      <header>
        <nav>
          <a :class="{ on: select.sort === i }" v-for="(v, i) in select.sortList" :key="v"
            @click="select.sort = i"><span>{{ v }}</span></a>
        </nav>
        <p>共<b>{{ nowMax }}</b>条信息</p>
      </header>
      <ul class="list">
        <li v-for="(v, i) in nowList" :key="i" @click="goDetail(v.VisaProductID)">
          <figure>
            <img
              src="http://tp.cstravel.cn/ImageUpload/VisaProduct/VisaProduct/20161201/e1149b567cf941c0a8c62b6c819b068f_6.jpg"
              alt="" />
            <div class="info">
              <h5>{{ v.Name }}</h5>
              <p>办理周期：{{ v | getCycle }}</p>
              <dl>
                <dt>套餐：</dt>
                <dd>
                  <template v-for="(sub, index) in v.visa_prices">
                    <a :class="{ on: v.selectVisa === index }" :key="sub.Id" v-if="index < 4"
                      @click.stop="goDetail(v.VisaProductID, sub.Id)">{{ sub.Name }}</a>
                  </template>
                </dd>
              </dl>
              <el-tag size="small" type="warning" v-for="s in v.serves" :key="s">{{ s }}</el-tag>
            </div>
          </figure>
          <p class="price">
            <b>{{ v.min_price }}</b>
            <button>立即预定</button>
            <span v-show="v.visa_prices.length > 4">更多套餐 <i class="icon-you"></i><i class="icon-you"></i></span>
          </p>
        </li>
      </ul>
      <el-pagination background layout="prev, pager, next" :current-page="select.page" :total="nowMax"
        :hide-on-single-page="true" @current-change="currentChange">
      </el-pagination>
    </section>
  </main>
</template>

<script>
import search from '@components/search';
export default {
  components: {
    search
  },
  data() {
    return {
      loading: true,
      info: {
        id: null,
        name: null
      },
      list: [],
      nowMax: 0,
      nowList: [],
      select: {
        typeIndex: null,
        types: [],
        formIndex: null,
        forms: [],
        serveIndex: null,
        serves: [],
        sort: 0,
        sortList: ['综合排序', '价格'],
        page: 1
      }
    }
  },
  created() {
    const info = this.$route.query;
    this.info = info;
    // 无参返回
    if (!info.id) { this.$router.push({ name: 'visa' }); return; }

    this.getList(info.id);
    // 设置title
    this.setTitle(info.name);
    this.scrollTo();
  },
  computed: {
    // 获取选中标签
    getSelected() {
      const {
        typeIndex,
        types,
        formIndex,
        forms,
        serveIndex,
        serves } = this.select;
      let res = [];
      typeIndex !== null && res.push({ index: typeIndex, value: types[typeIndex] });
      formIndex !== null && res.push({ index: formIndex, value: forms[formIndex] });
      serveIndex !== null && res.push({ index: serveIndex, value: serves[serveIndex] });
      return res;
    }
  },
  methods: {
    // 修改列表
    changeKeyWord({ id }) {
      this.getList(id);
    },
    // 切换页码
    currentChange(page) {
      this.select = { ...this.select, page };
      this.updateList();
    },
    // 更新显示列表
    updateList() {
      let list = [...this.list];
      let index = 10;
      // 提取符合规则的列表
      list = list.filter(v => {
        const { typeIndex, types, formIndex, forms, serveIndex, serves } = this.select;
        // 签证类别
        if (typeIndex !== null && types[typeIndex] !== v.KindName) { return false; }
        // 签证形式
        if (formIndex !== null && forms[formIndex] !== v.FormName) { return false; }
        // 服务承诺
        if (serveIndex !== null && v.serves.includes(serves[serveIndex]) === false) { return false; }
        return true;
      });
      // 价格排序
      const { sort } = this.select;
      if (sort === 1) {
        list.sort((a, b) => a.min_price - b.min_price);
      }
      const max = list.length;
      // 页码
      const { page } = this.select;
      list = list.filter((v, i) => {
        const start = (page - 1) * index;
        return (i >= start && i < start + index);
      });
      this.nowList = list;
      this.nowMax = max;
    },
    // 请求列表数据
    getList(id) {
      this.loading = true;
      this.$axios.get(`/VisaProduct/byCountry/${id}`).then(({ products }) => {
        let forms = [], types = [], serves = [];
        let list = products.map(v => {
          // 签证形式
          forms.includes(v.FormName) === false && forms.push(v.FormName);
          // 签证类别
          types.includes(v.KindName) === false && types.push(v.KindName);
          // 服务承诺
          const serve = v.Promise.split(',');
          serve.forEach(serve => {
            if (!serve) { return; }
            serves.includes(serve) === false && serves.push(serve);
          });
          // 分割数据
          v.serves = serve.filter(v => !!v);
          v.selectVisa = 0;
          return v;
        });
        this.list = list;
        this.select = {
          ...this.select,
          typeIndex: null, types,
          formIndex: null, forms,
          serveIndex: null, serves
        };
        this.updateList();
        this.loading = false;
      }).catch(err => {
        this.$message.warning('请求数据失败，请稍后再试！');
        this.loading = false;
      })
    },
    // 跳转详情
    goDetail(id, mealId) {
      let query = { id };
      !!mealId && (query.mealId = mealId);
      this.$router.push({ path: './visa_detail', query });
    },
    // 删除选中信息
    clearSelected() {
      this.select = { ...this.select, typeIndex: null, formIndex: null, serveIndex: null };
      this.updateList();
    },
    // 修改选中信息
    changeSelect(attr, val) {
      let select = { ...this.select };
      select[attr] = select[attr] === val ? null : val;
      select.page = 1;
      this.select = select;
      this.updateList();
    }
  },
  filters: {
    getCycle(item) {
      const { visa_prices, selectVisa } = item;
      const day = ~~visa_prices[selectVisa].ProcessingDays;
      let res;
      if (day === 0) { res = '0~1个工作日' }
      else if (day < 4) { res = `${day - 1}~${day}个工作日` }
      else if (day >= 4) { res = `${day - 2}~${day}个工作日` }
      else { res = '--' }
      return res;
    }
  }
}
</script>
<style scoped src="./list.css"></style>